import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=7dd7e0df&scoped=true"
import script from "./productOrder.vue?vue&type=script&lang=js"
export * from "./productOrder.vue?vue&type=script&lang=js"
import style0 from "./productOrder.vue?vue&type=style&index=0&id=7dd7e0df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd7e0df",
  null
  
)

export default component.exports